import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { prettyDate } from "@/lib/geo";

const KIND = { idea: ["Idea", "#FBBF24"], request: ["Request", "#38BDF8"], problem: ["Not working", "#F87171"] };

const Item = ({ f }) => {
  const qc = useQueryClient();
  const toggle = async () => {
    await api.setFeedbackStatus(f.feedback_id, f.status === "done" ? "new" : "done").catch(() => toast.error("Couldn't update"));
    qc.invalidateQueries({ queryKey: ["admin-feedback"] });
  };
  const [label, color] = KIND[f.kind];
  return (
    <li className={`py-5 grid gap-3 sm:grid-cols-[1fr_auto] ${f.status === "done" ? "opacity-60" : ""}`} data-testid={`feedback-item-${f.feedback_id}`}>
      <div className="min-w-0">
        <p className="text-xs flex flex-wrap items-center gap-2">
          <span className="px-2 py-0.5 rounded-full border" style={{ color, borderColor: `${color}55` }}>{label}</span>
          <span className="text-slate-300">{f.name || "Anonymous"}</span>
          {f.email && <a href={`mailto:${f.email}`} className="text-sky-300 hover:underline inline-flex items-center gap-1"><Mail size={11} />{f.email}</a>}
          <span className="font-mono text-[10px] text-slate-600">{prettyDate(f.created_at.slice(0, 10), "d MMM yyyy")} · {f.page || "/"}</span>
        </p>
        <p className="mt-2 text-sm text-slate-200 whitespace-pre-line">{f.message}</p>
      </div>
      <button onClick={toggle} data-testid={`feedback-status-${f.feedback_id}`}
        className={`self-start px-3 py-1 rounded-full text-xs border transition-colors ${f.status === "done" ? "border-emerald-400/40 text-emerald-300" : "border-white/15 text-slate-300 hover:border-emerald-400/50"}`}>
        {f.status === "done" ? "Done ✓" : "Mark done"}
      </button>
    </li>
  );
};

export const FeedbackList = () => {
  const { data, isLoading } = useQuery({ queryKey: ["admin-feedback"], queryFn: api.adminFeedback });
  if (isLoading) return <p className="mt-8 text-sm text-slate-500">Loading…</p>;
  return (
    <ul className="max-w-4xl mt-4 divide-y divide-white/5 border-y border-white/5" data-testid="feedback-list">
      {(data || []).map((f) => <Item key={f.feedback_id} f={f} />)}
      {!data?.length && <li className="py-10 text-sm text-slate-500" data-testid="feedback-empty">No messages yet.</li>}
    </ul>
  );
};
